<template>
  <section>
    <h1>ご利用できません。</h1>
    <p>
      現在お客様は利用制限をかけさせて頂いております。<br>
      お問い合わせは下記のメールアドレスにお送り下さい。
    </p>
    <p>運営事務局：{{ settingData.inquiry_mail }}</p>
  </section>
</template>

<script>
export default {
  name: 'RestrictionLock',
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null,
      settingData: []
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  },
  methods: {
    getDefaultSetting () {
      this.$store.dispatch('getDefaultSetting')
        .then((data) => {
          this.settingData = data
        })
    }
  },
  created () {
    this.getDefaultSetting()
  }
}
</script>
